import { render, staticRenderFns } from "./FaqHome.vue?vue&type=template&id=8646e18c&"
import script from "./FaqHome.vue?vue&type=script&lang=ts&"
export * from "./FaqHome.vue?vue&type=script&lang=ts&"
import style0 from "./FaqHome.vue?vue&type=style&index=0&id=8646e18c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports